// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

function promise(procedure) {
  return new Promise((function (resolve, reject) {
                try {
                  return Curry._1(procedure, (function (result) {
                                resolve(result);
                              }));
                }
                catch (raw_exn){
                  var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                  return reject(exn);
                }
              }));
}

function promiseFlatMap(promise, mapper) {
  return Js_promise.then_(mapper, promise);
}

function promiseMap(promise, mapper) {
  var mapper$1 = function (value) {
    return Promise.resolve(Curry._1(mapper, value));
  };
  return Js_promise.then_(mapper$1, promise);
}

exports.promise = promise;
exports.promiseFlatMap = promiseFlatMap;
exports.promiseMap = promiseMap;
/* No side effect */
